<template>
	<div>
		<v-stepper v-if="steps" v-model="index" vertical class="wizardStepper">
			<div v-for="(step, i) in steps" :key="i">
				<v-stepper-step :step="i + 1" :complete="index > i + 1">{{
					step.title
				}}</v-stepper-step>
				<v-stepper-content
					:class="{ 'mobile-fullwidth-stepper': $vuetify.breakpoint.xsOnly }"
					:step="i + 1"
				>
					<v-card>
						<component
							:is="step.component"
							v-if="step.component"
							:ref="`component-${i + 1}`"
							:step="step"
							:unpair="unpair"
						/>
						<v-card-text v-else-if="step.text">{{ step.text }}</v-card-text>
					</v-card>
				</v-stepper-content>
			</div>
		</v-stepper>
		<v-toolbar bottom dark class="wizardToolbar">
			<v-btn :disabled="disableBack" text @click="back">Back</v-btn>
			<v-spacer />
			<v-btn :disabled="disableNext" text @click="next">Next</v-btn>
		</v-toolbar>
	</div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
	computed: {
		...mapState("wizard", [
			"steps",
			"index",
			"unpair",
			"disableNext",
			"disableBack",
		]),
	},
	methods: {
		...mapActions("wizard", ["next", "back"]),
	},
};
</script>

<style>
.wizardToolbar {
	position: fixed;
	width: 100%;
	bottom: 0;
	z-index: 999;
}
.wizardStepper {
	margin-bottom: 50px;
}
.v-stepper--vertical .v-stepper__content.mobile-fullwidth-stepper {
	width: 100%;
	padding: 24px 12px 16px 12px;
	margin: 0;
}
</style>
